<template>
    <div>
        <!-- PROPS Inline white color outline icon button -->
        <button v-if="object=='prop'" type="button" class="details-share-btn d-flex" @click="showShare(index)">
            <svg width="18" height="18" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2.76316 10.4C3.48158 10.4 4.13132 10.1136 4.62395 9.656L9.56605 12.5176C9.50753 12.7403 9.4765 12.9695 9.47368 13.2C9.47368 14.744 10.7132 16 12.2368 16C13.7605 16 15 14.744 15 13.2C15 11.656 13.7605 10.4 12.2368 10.4C11.5184 10.4 10.8687 10.6864 10.3761 11.144L5.43395 8.2824C5.48368 8.0848 5.51526 7.8808 5.51921 7.668L10.3753 4.856C10.8687 5.3136 11.5184 5.6 12.2368 5.6C13.7605 5.6 15 4.344 15 2.8C15 1.256 13.7605 0 12.2368 0C10.7132 0 9.47368 1.256 9.47368 2.8C9.47368 3.0368 9.51158 3.2624 9.56605 3.4824L5.07868 6.0816C4.82901 5.68906 4.4863 5.36613 4.08183 5.14227C3.67737 4.9184 3.22402 4.80073 2.76316 4.8C1.23947 4.8 0 6.056 0 7.6C0 9.144 1.23947 10.4 2.76316 10.4ZM12.2368 12C12.8897 12 13.4211 12.5384 13.4211 13.2C13.4211 13.8616 12.8897 14.4 12.2368 14.4C11.5839 14.4 11.0526 13.8616 11.0526 13.2C11.0526 12.5384 11.5839 12 12.2368 12ZM12.2368 1.6C12.8897 1.6 13.4211 2.1384 13.4211 2.8C13.4211 3.4616 12.8897 4 12.2368 4C11.5839 4 11.0526 3.4616 11.0526 2.8C11.0526 2.1384 11.5839 1.6 12.2368 1.6ZM2.76316 6.4C3.41605 6.4 3.94737 6.9384 3.94737 7.6C3.94737 8.2616 3.41605 8.8 2.76316 8.8C2.11026 8.8 1.57895 8.2616 1.57895 7.6C1.57895 6.9384 2.11026 6.4 2.76316 6.4Z" fill="white"/>
            </svg>
        </button>
        <!-- PROPS Inline dots icon button -->
        <button v-else-if="object=='prop-dots'" type="button" class="details-share-btn" @click="showShare(index)">
            <svg width="5" height="20" viewBox="0 0 5 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2.69255 19.046C3.96657 19.046 4.99936 18.0779 4.99936 16.8837C4.99936 15.6894 3.96657 14.7213 2.69255 14.7213C1.41854 14.7213 0.385742 15.6894 0.385742 16.8837C0.385742 18.0779 1.41854 19.046 2.69255 19.046Z" fill="white"/>
                <path d="M2.69338 12.126C3.9674 12.126 5.00019 11.1579 5.00019 9.96363C5.00019 8.76939 3.9674 7.80127 2.69338 7.80127C1.41937 7.80127 0.386571 8.76939 0.386571 9.96363C0.386571 11.1579 1.41937 12.126 2.69338 12.126Z" fill="white"/>
                <path d="M2.6929 5.20754C3.96691 5.20754 4.99971 4.23942 4.99971 3.04518C4.99971 1.85094 3.96691 0.882813 2.6929 0.882812C1.41888 0.882812 0.386084 1.85094 0.386084 3.04518C0.386084 4.23942 1.41888 5.20754 2.6929 5.20754Z" fill="white"/>
            </svg>
        </button>
        <!-- AGENTS Inline Gray background icon button -->
        <button v-else-if="object=='agent-sm'" type="button" @click="showShare(index)">
            <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="50" height="50" rx="25" fill="#0F0D0D"/>
                <path d="M31.6667 30.271C30.8227 30.271 30.0613 30.6119 29.484 31.1606L21.5667 26.3619C21.628 26.1014 21.6667 25.8298 21.6667 25.5527C21.6667 25.2755 21.628 25.0053 21.5667 24.7448L29.4 19.9932C30.0133 20.5937 30.824 20.9283 31.6667 20.9285C33.5053 20.9285 35 19.3752 35 17.4643C35 15.5534 33.5053 14 31.6667 14C29.828 14 28.3333 15.5534 28.3333 17.4643C28.3333 17.7414 28.372 18.013 28.4333 18.2721L20.6 23.0237C19.9863 22.4238 19.1758 22.0893 18.3333 22.0884C16.4947 22.0884 15 23.6418 15 25.5527C15 27.4635 16.4947 29.0169 18.3333 29.0169C19.176 29.0167 19.9867 28.6821 20.6 28.0816L28.5173 32.8803C28.459 33.128 28.429 33.3819 28.428 33.6369C28.4283 34.3022 28.6183 34.9525 28.9741 35.5056C29.33 36.0587 29.8356 36.4897 30.4271 36.7442C31.0186 36.9986 31.6694 37.0651 32.2972 36.9353C32.9251 36.8054 33.5018 36.485 33.9545 36.0146C34.4071 35.5441 34.7154 34.9447 34.8404 34.2922C34.9654 33.6397 34.9014 32.9633 34.6565 32.3486C34.4116 31.7339 33.9969 31.2084 33.4647 30.8386C32.9326 30.4688 32.3068 30.2713 31.6667 30.271Z" fill="#515151"/>
            </svg>
        </button>
        <!-- AGENTS Inline desktop icon button -->
        <div v-else-if="object=='agent-lg'" class="d-flex align-items-center py-3">
            <button type="button" @click="showShare(index)" class="details-side-btn">
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="48" height="48" rx="24" fill="#282828"/>
                    <path d="M30.3999 29.0601C29.5897 29.0601 28.8588 29.3873 28.3045 29.9141L20.7039 25.3074C20.7628 25.0573 20.7999 24.7965 20.7999 24.5305C20.7999 24.2644 20.7628 24.005 20.7039 23.7549L28.2239 19.1934C28.8127 19.7699 29.591 20.0911 30.3999 20.0913C32.165 20.0913 33.5999 18.6001 33.5999 16.7656C33.5999 14.9312 32.165 13.4399 30.3999 13.4399C28.6348 13.4399 27.1999 14.9312 27.1999 16.7656C27.1999 17.0317 27.237 17.2924 27.2959 17.5412L19.7759 22.1027C19.1868 21.5268 18.4087 21.2057 17.5999 21.2048C15.8348 21.2048 14.3999 22.696 14.3999 24.5305C14.3999 26.3649 15.8348 27.8562 17.5999 27.8562C18.4088 27.856 19.1871 27.5348 19.7759 26.9583L27.3765 31.565C27.3206 31.8028 27.2918 32.0466 27.2908 32.2914C27.291 32.9301 27.4735 33.5543 27.8151 34.0853C28.1567 34.6162 28.6421 35.03 29.2099 35.2743C29.7777 35.5186 30.4025 35.5825 31.0052 35.4578C31.608 35.3331 32.1616 35.0256 32.5962 34.5739C33.0308 34.1223 33.3267 33.5469 33.4467 32.9205C33.5666 32.2941 33.5052 31.6447 33.2701 31.0546C33.0351 30.4645 32.6369 29.96 32.126 29.605C31.6152 29.25 31.0145 29.0604 30.3999 29.0601Z" fill="#515151"/>
                </svg>
            </button>
            <div class="details-side-chatbox">Share this property</div>
        </div>
        <!-- ARTICLE dialog box desktop icon -->
        <div v-else-if="object=='article-d'" class="d-flex align-items-center">
            <button type="button" @click="showShare(index)">
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="48" height="48" rx="24" fill="white"/>
                    <path d="M30.3999 29.0602C29.5897 29.0602 28.8588 29.3874 28.3045 29.9142L20.7039 25.3074C20.7628 25.0573 20.7999 24.7966 20.7999 24.5306C20.7999 24.2645 20.7628 24.0051 20.7039 23.755L28.2239 19.1935C28.8127 19.77 29.591 20.0912 30.3999 20.0914C32.165 20.0914 33.5999 18.6002 33.5999 16.7657C33.5999 14.9312 32.165 13.44 30.3999 13.44C28.6348 13.44 27.1999 14.9312 27.1999 16.7657C27.1999 17.0318 27.237 17.2925 27.2959 17.5413L19.7759 22.1028C19.1868 21.5268 18.4087 21.2058 17.5999 21.2049C15.8348 21.2049 14.3999 22.6961 14.3999 24.5306C14.3999 26.365 15.8348 27.8563 17.5999 27.8563C18.4088 27.856 19.1871 27.5348 19.7759 26.9583L27.3765 31.5651C27.3206 31.8028 27.2918 32.0466 27.2908 32.2914C27.291 32.9301 27.4735 33.5544 27.8151 34.0854C28.1567 34.6163 28.6421 35.0301 29.2099 35.2744C29.7777 35.5187 30.4025 35.5825 31.0052 35.4579C31.608 35.3332 32.1616 35.0256 32.5962 34.574C33.0308 34.1223 33.3267 33.547 33.4467 32.9205C33.5666 32.2941 33.5052 31.6448 33.2701 31.0547C33.0351 30.4645 32.6369 29.9601 32.126 29.6051C31.6152 29.25 31.0145 29.0604 30.3999 29.0602Z" fill="#D80000"/>
                </svg>
            </button>
            <div class="details-side-chatbox ml-3 visible">Share this article</div>
        </div>
        <!-- ARTICLE floating mobile icon -->
        <button v-else-if="object=='article-m'" type="button" @click="showShare(index)" class="position-fixed dn-mb" style="bottom: 30px; right: 30px;">
            <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="48" height="48" rx="24" fill="#D80000"/>
                <path d="M30.3999 29.0602C29.5897 29.0602 28.8588 29.3874 28.3045 29.9142L20.7039 25.3074C20.7628 25.0573 20.7999 24.7966 20.7999 24.5306C20.7999 24.2645 20.7628 24.0051 20.7039 23.755L28.2239 19.1935C28.8127 19.77 29.591 20.0912 30.3999 20.0914C32.165 20.0914 33.5999 18.6002 33.5999 16.7657C33.5999 14.9312 32.165 13.44 30.3999 13.44C28.6348 13.44 27.1999 14.9312 27.1999 16.7657C27.1999 17.0318 27.237 17.2925 27.2959 17.5413L19.7759 22.1028C19.1868 21.5268 18.4087 21.2058 17.5999 21.2049C15.8348 21.2049 14.3999 22.6961 14.3999 24.5306C14.3999 26.365 15.8348 27.8563 17.5999 27.8563C18.4088 27.856 19.1871 27.5348 19.7759 26.9583L27.3765 31.5651C27.3206 31.8028 27.2918 32.0466 27.2908 32.2914C27.291 32.9301 27.4735 33.5544 27.8151 34.0854C28.1567 34.6163 28.6421 35.0301 29.2099 35.2744C29.7777 35.5187 30.4025 35.5825 31.0052 35.4579C31.608 35.3332 32.1616 35.0256 32.5962 34.574C33.0308 34.1223 33.3267 33.547 33.4467 32.9205C33.5666 32.2941 33.5052 31.6448 33.2701 31.0547C33.0351 30.4645 32.6369 29.9601 32.126 29.6051C31.6152 29.25 31.0145 29.0604 30.3999 29.0602Z" fill="#FFFFFF"/>
            </svg>
        </button>

        <div id="share-modal">
            <!-- Property Modal -->
            <modal :name="index" width="500px" height="auto" @closed="$emit('remove')">
                <div slot="top-right">
                    <button @click="hideShare(index)" class="video-modal-xbtn">✕</button>
                </div>
                <div class="float-message">Tap anywhere to dismiss</div>
                <div style="background:white;position:relative;">
                    <h5 class="modal-title text-capitalize">Share {{label.toLowerCase()}}</h5>
                    <div class="d-flex justify-content-center align-items-center py-3">
                        <ShareNetwork network="facebook" :url="domainurl"
                            :title="text"
                            description=""
                            :quote="text" 
                            hashtags="shijieproperty">
                            <i class="fab fa-facebook-square" style="color:#3b5998;margin:10px;font-size:35px;cursor:pointer;"></i>
                        </ShareNetwork>
                        <ShareNetwork network="whatsapp" :url="domainurl"
                            :title="text" 
                            description="">
                            <i class="fab fa-whatsapp-square" style="color:#25D366;margin:10px;font-size:35px;cursor:pointer;"></i>
                        </ShareNetwork>
                        <ShareNetwork network="twitter" :url="domainurl"
                            :title="text"
                            description="..."
                            twitter-user='shijieproperty'
                            hashtags='shijieproperty,property'>
                            <i class="fab fa-twitter-square" style="color:#34B7F1;margin:10px;font-size:35px;cursor:pointer;"></i>
                        </ShareNetwork>
                        <!-- wechat -->
                        <div @click="weChat = true" class="position-relative wechat-share-icon">
                            <share 
                                :shareType="shareType" 
                                shareDirection="transverse"
                                :shareTitle="text"
                                :shareUrl="domainurl"
                            ></share>
                        </div>
                        <!-- end -->
                        <ShareNetwork network="line" :url="domainurl"
                            :title="text" 
                            description="">
                            <i class="fab fa-line" style="color:#00C300;margin:10px;font-size:35px;cursor:pointer;"></i>
                        </ShareNetwork>
                        <a :href="'http://www.linkedin.com/shareArticle?mini=true&url='+domainurl" target="_blank" rel="noopener noreferrer">
                            <i class="fab fa-linkedin" style="color:#0E76A8;margin:10px;font-size:35px;cursor:pointer;"></i>
                        </a>
                    </div>
                    <div v-if="!mView && weChat" class="wechat-note">Go to WeChat Discover tab and Scan the QR code above, then click the '...' on the top right corner to share.</div>
                    <div v-else-if="mView && weChat" class="d-flex flex-column m-wechat-note">
                        <input id="wechat-link" class="cal-form align-self-center w-100" v-model="wechatLink" />
                        <div class="d-flex justify-content-center">
                            <button id="copy-btn" class="btn btn-outline-danger cal-btn mt-3 mb-0" @click="copyText">Copy Link</button>
                            <a class="btn wechat-btn" href="weixin://">Open WeChat</a>
                        </div>
                    </div>
                </div>
            </modal>
        </div>
    </div>
</template>

<script>
import share from 'vue2-share';
    export default {
        props: ['index', 'object', 'title', 'text', 'label', 'url', 'manualToggle'],
        components: {
            share
        },
        data() {
            return {
                domainurl: window.location.protocol + "//" + window.location.host + this.url,
                wechatLink: window.location.protocol + "//" + window.location.host + this.url,
                shareType:['wx'],
                weChat: false,
                mView: false,
            }
        },
        watch: {
            manualToggle: function (val) {
                if(val == this.index) {
                    this.showShare(this.index)
                }
                else {
                    this.hideShare(this.index);
                }
            }
        },
        mounted() {
            var vw = window.innerWidth;
            if (vw < 991) {
                this.mView = true;
            }
        },
        methods: {
            copyText: function() {
                var copyText = document.getElementById("wechat-link");
                copyText.select();
                copyText.setSelectionRange(0, 99999)
                document.execCommand("copy");
                document.getElementById('copy-btn').innerHTML = 'Copied';
            },
            showShare: function(id) {
                if (this.webShareApiSupported && this.mView) {
                    this.shareViaWebShare();
                } else {
                    this.$modal.show(id);
                }
            },
            hideShare: function(id) {
                this.$modal.hide(id);
                this.weChat = false;  
            },
            shareViaWebShare() {
                let vm = this;
                navigator.share({
                    title: vm.title,
                    text: vm.text,
                    url: vm.domainurl,
                })
            }
        },
        computed: {
            webShareApiSupported() {
                return navigator.share
            }
        }
    }
</script>

<style scoped>
    .modal-title {
        font-size: 16px;
        color: #212529 !important;
        padding: 20px;
    }
    .float-message {
        position: fixed;
        z-index: 0;
        left: 50%;
        transform: translate(-50%, 0);
        bottom: 30%;
        color: white;
        font-size: 14px;
        pointer-events: none;
    }
</style>